exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.section_itemsummary .samediv {\n    padding-bottom: 20px;\n    display: -webkit-box;\n    display: flex;\n    -webkit-box-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n            justify-content: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n            flex-direction: column;\n}\n.section_itemsummary .samediv:last-child {\n    padding-bottom: 0;\n}\n.section_itemsummary .samediv p{\n    width: 100%;\n    text-align: left;\n}\n.section_itemsummary .samediv button{\n    padding: 0 20px;\n}\n", ""]);

// exports
